import { axios } from '@/plugins/axios';
import { endPoints, Params } from '../types/api';
import { useNotification } from './useNotification';

export const useSchool = () => {
  const { showNotification } = useNotification();

  const savePublishDate = (payload: Params<'savePublishDate'>) => {
    return axios.post(endPoints.savePublishDate.endPoint, payload).then(() => {
      showNotification({
        isShow: true,
        message: '公開日を変更しました',
        type: 'success',
      });
    });
  };

  const toPrivate = (payload: Params<'forcedPublishDisable'>) => {
    return axios
      .post(endPoints.forcedPublishDisable.endPoint, payload)
      .then(() => {
        showNotification({
          isShow: true,
          message: '公開を停止しました',
          type: 'success',
        });
      });
  };

  const resetPublish = (payload: Params<'resetPublish'>) => {
    return axios.post(endPoints.resetPublish.endPoint, payload).then(() => {
      showNotification({
        isShow: true,
        message: '公開情報をリセットしました',
        type: 'success',
      });
    });
  };

  const changeEnabled = (payload: Params<'changeEnabled'>) => {
    return axios.post(endPoints.changeEnabled.endPoint, payload);
  };

  const cancellationPrivate = (payload: Params<'cancellationPrivate'>) => {
    return axios
      .post(endPoints.cancellationPrivate.endPoint, payload)
      .then(() => {
        showNotification({
          isShow: true,
          message: '強制非公開を解除しました',
          type: 'success',
        });
      });
  };

  return {
    savePublishDate,
    toPrivate,
    resetPublish,
    changeEnabled,
    cancellationPrivate,
  };
};
